import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { MultiCategoryHomepageRBAC } from '../pages/MulticategoryHomepageList/rbac'
import { MultiCategoryHomepageCreateEditRBAC } from '../pages/MutlicategoryHomepageCreateEdit/rbac'

const MulticategoryHomepageList = lazy(() => import('../pages/MulticategoryHomepageList'))
const MutlicategoryHomepageCreateEdit = lazy(
  () => import('../pages/MutlicategoryHomepageCreateEdit'),
)

export const MultiCategoryHomepageListRouter: RouterFeatureInterface<
  'MultiCategoryHomepageListRouter',
  '/dashboard/multicategory'
> = {
  name: 'MultiCategoryHomepageListRouter',
  Component: MulticategoryHomepageList,
  path: '/dashboard/multicategory',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MultiCategoryHomepageRBAC.pageID,
}

// `:tab?` optional segment drives the active step (router-per-tab). The
// top-level route is `exact`, so the optional param lets both `/create` and
// `/create/:tab` match this single entry.
export const MultiCategoryHomepageCreateRouter: RouterFeatureInterface<
  'MultiCategoryHomepageCreateRouter',
  '/dashboard/multicategory/create/:tab?'
> = {
  name: 'MultiCategoryHomepageCreateRouter',
  Component: MutlicategoryHomepageCreateEdit,
  path: '/dashboard/multicategory/create/:tab?',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MultiCategoryHomepageCreateEditRBAC.pageID,
}

export const MultiCategoryHomepageEditRouter: RouterFeatureInterface<
  'MultiCategoryHomepageEditRouter',
  '/dashboard/multicategory/edit/:id/:tab?'
> = {
  name: 'MultiCategoryHomepageEditRouter',
  Component: MutlicategoryHomepageCreateEdit,
  path: '/dashboard/multicategory/edit/:id/:tab?',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MultiCategoryHomepageCreateEditRBAC.pageID,
}

const MultiCategoryRouter = [
  MultiCategoryHomepageListRouter,
  MultiCategoryHomepageCreateRouter,
  MultiCategoryHomepageEditRouter,
]

export const MultiCategoryRouterDetail = generateRouterDetail(MultiCategoryRouter)

export default MultiCategoryRouter
